// extracted by mini-css-extract-plugin
export default {"root":"LibraryPage-module__root_lrNwY","librarySwitch":"LibraryPage-module__librarySwitch_vdWE6","mobile-ui":"mobile-ui","mobileAppPage":"LibraryPage-module__mobileAppPage_HaIRB"};